import React from 'react';
import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
import { NavigateNext } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

export interface BreadcrumbItem {
    label: string;
    path?: string;
    icon?: React.ReactNode;
}

interface BreadcrumbProps {
    items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleClick = (path?: string) => {
        if (path && path !== location.pathname) {
            navigate(path);
        }
    };

    return (
        <Box sx={{ mb: 2 }}>
            <Breadcrumbs 
                separator={<NavigateNext fontSize="small" />}
                aria-label="breadcrumb"
                sx={{
                    '& .MuiBreadcrumbs-separator': {
                        mx: 1
                    }
                }}
            >
                {items.map((item, index) => {
                    const isLast = index === items.length - 1;
                    
                    if (isLast) {
                        return (
                            <Box
                                key={index}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5
                                }}
                            >
                                {item.icon}
                                <Typography color="text.primary">
                                    {item.label}
                                </Typography>
                            </Box>
                        );
                    }

                    return (
                        <Link
                            key={index}
                            color="inherit"
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                handleClick(item.path);
                            }}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                textDecoration: 'none',
                                '&:hover': {
                                    textDecoration: 'underline',
                                    cursor: 'pointer'
                                }
                            }}
                        >
                            {item.icon}
                            {item.label}
                        </Link>
                    );
                })}
            </Breadcrumbs>
        </Box>
    );
};

export default Breadcrumb;